<style scoped lang="scss">
.leaflet-container .leaflet-marker-pane img.map-marker-image {
  max-width: 100% !important;
  padding: 2px;
}
</style>

<style src="leaflet/dist/leaflet.css"></style>
<template>
  <div class="row">
    <div class="col-12 p-0">
      <div id="map" class="map"></div>
    </div>
  </div>
</template>
<script>
import L from "leaflet";
export default {
  data() {
    return {
      defaultCoordinates: {
        DE: { lat: "50.808420", lon: "10.110305" },
        AT: { lat: "47.352928", lon: "14.340452" },
        CH: { lat: "46.955298", lon: "8.352276" }
      },
      map: null,
      distance: 0,
      data: { adresses: [], distance: null }
    };
  },
  computed: {
    hasMyProfile() {
      return Boolean(this.my_profile);
    }
  },
  methods: {
    initMap() {
      this.map = L.map("map");
      var osmUrl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";
      var osmAttrib =
        'Map data © <a href="https://openstreetmap.org">OpenStreetMap</a> contributors';
      var osm = new L.TileLayer(osmUrl, {
        minZoom: 4,
        maxZoom: 14,
        attribution: osmAttrib
      });
      this.map.addLayer(osm);
      return this.map;
    },
    userDistanceKm(coords) {
      let latDiff = 111.3 * Math.abs(coords[0][0] - coords[1][0]);
      let lonDiff = 71.5 * Math.abs(coords[0][1] - coords[1][1]);
      return Math.round(
        Math.pow(Math.pow(latDiff, 2) + Math.pow(lonDiff, 2), 0.5)
      );
    },
    getMarker(coord, profile, bgClass = "bg-success") {
      let icon = L.divIcon({
        html:
          "<img class='map-marker-image rounded " +
          bgClass +
          "' src='" +
          profile.primary_image.url +
          "?width=46&height=46" +
          "' />",
        iconSize: [46, 46],
        popupAnchor: [-3, -23],
        className: "myDivIcon"
      });

      let marker = L.marker(coord, { icon: icon }).bindPopup(
        "<strong class='text-primary text-md'>" + profile.name + "</strong>"
      );

      return marker;
    }
  },
  async mounted() {
    let map = this.initMap();
    let markers = [];
    let coords = [];

    if (this.hasMyProfile && this.other_profile.id == this.my_profile.id) {
      this.my_profile.friends_with_anonymous_location.forEach(profile => {
        let coord = profile.anonymous_location.latitude
          ? [
              profile.anonymous_location.latitude,
              profile.anonymous_location.longitude
            ]
          : null;

        let marker = this.getMarker(coord, profile);
        if (coord) {
          if (
            !coords.some(c => {
              return c[0] === coord[0] && c[1] === coord[1];
            })
          ) {
            L.circle(coord, {
              radius: profile.anonymous_location.diameter / 2
            }).addTo(map);
          }

          markers.unshift(marker); // Marker for other profiles will be before
          coords.push(coord);
          map.addLayer(marker);
        }
      });
    } else {
      let coord = [
        this.other_profile.anonymousLocation.latitude,
        this.other_profile.anonymousLocation.longitude
      ];

      let marker = this.getMarker(coord, this.other_profile);
      L.circle(coord, {
        radius: this.other_profile.anonymousLocation.diameter / 2
      }).addTo(map);

      coords.push(coord);
      map.addLayer(marker);
      markers.push(marker); // "You"-marker will be last
    }

    if (this.hasMyProfile) {
      let coord = [
        this.my_profile.anonymousLocation.latitude,
        this.my_profile.anonymousLocation.longitude
      ];

      let marker = this.getMarker(coord, this.my_profile, "bg-danger");

      if (
        !coords.some(c => {
          return c[0] === coord[0] && c[1] === coord[1];
        })
      ) {
        L.circle(coord, {
          radius: this.my_profile.anonymousLocation.diameter / 2
        }).addTo(map);
      }

      coords.push(coord);
      map.addLayer(marker);
      markers.push(marker); // "You"-marker will be last
    }

    if (this.hasMyProfile && this.other_profile.id != this.my_profile.id) {
      markers[0].openPopup();
      L.polyline(coords, { dashArray: "20,15" }).addTo(map);
      this.data.distance = this.userDistanceKm(coords);
    }
    map.fitBounds(new L.featureGroup(markers).getBounds().pad(0.01));
    this.$emit("input", this.data);
  },

  props: {
    my_profile: {
      required: true,
      validator: prop => typeof prop === "object" || prop === null
    },
    other_profile: {
      required: false,
      type: Object,
      default: null
    }
  }
};
</script>
